import React, { PropsWithChildren } from 'react'

import { create as createActions } from '@frame/lib/actions'
import { create as createApi } from '@frame/lib/api'
import { RootContextProvider } from '@frame/lib/context'
import { events } from '@frame/lib/events'

type Props = PropsWithChildren<{
  api: ReturnType<typeof createApi>
  events: typeof events
  actions: ReturnType<typeof createActions>
}>

export function RootContext({ api, events, actions, children }: Props) {
  return <RootContextProvider value={{ api, events, actions }}>{children}</RootContextProvider>
}
